import React, { useEffect, useState } from "react";
import "./SetlistCountdownRing.css";
import { t as tr } from "../i18n";
import { T } from "../i18n/T";

// The 72-hour delivery window — compact pill (founder pick W2,
// replacing the 180px C2 ring that dwarfed the art). A 20px live ring +
// "71h left · delivery window" in one quiet capsule.
//
// The clock anchors on paidAt — the SAME anchor the server's expiry sweep
// uses (server jobs/expireUncapturedAuths, PLAYLIST_WINDOW_MS) — so what
// the fan sees and what the sweep enforces can never drift. The copy is a
// money-trust statement backed by capture-at-delivery + the 72h auto-cancel:
// an undelivered setlist never charges the fan.
//
// WORN NOTCH (founder, round 4): at 71h the honest drain is 1.4% —
// invisible, so the ring read as decorative. The drawn arc wears a minimum
// 8% bite while the TEXT stays exact; past 8% elapsed it tracks reality 1:1.

const WINDOW_MS = 72 * 60 * 60 * 1000;
const R = 8;
const CIRC = 2 * Math.PI * R;
const MIN_ELAPSED_SHOWN = 0.08;

const SetlistCountdownRing: React.FC<{
  paidAt?: string | null;
  createdAt?: string | null;
}> = ({ paidAt, createdAt }) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(t);
  }, []);

  const anchorIso = paidAt || createdAt;
  const start = anchorIso ? new Date(anchorIso).getTime() : now;
  const remaining = Math.max(0, start + WINDOW_MS - now);
  const elapsedFrac = Math.min(1, Math.max(0, (now - start) / WINDOW_MS));
  const shownFrac = Math.max(elapsedFrac, MIN_ELAPSED_SHOWN);
  const hours = Math.floor(remaining / 3_600_000);
  const label = hours >= 1 ? `${hours}h` : `${Math.max(1, Math.round(remaining / 60_000))}m`;

  return (
    <div className="scr72">
      <div className="scr72-pillrow">
        <span className="scr72-pill">
          <svg className="scr72-mini" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
            <circle cx="10" cy="10" r={R} stroke="#1a2130" strokeWidth="3" fill="none" />
            <circle
              cx="10"
              cy="10"
              r={R}
              stroke="#24C961"
              strokeWidth="3"
              fill="none"
              strokeLinecap="round"
              strokeDasharray={CIRC}
              strokeDashoffset={CIRC * shownFrac}
              transform="rotate(-90 10 10)"
            />
          </svg>
          <span className="scr72-txt">
            <T k="setlistCountdownRing.leftDeliveryWindow" vars={{ label }} tags={{ 0: (c) => <span>{c}</span> }} />
          </span>
        </span>
      </div>
      <div className="scr72-note">{tr("setlistCountdownRing.typicallyArrivesTheNext")}</div>
      <div className="scr72-trust">{tr("setlistCountdownRing.deliveredWithinHoursOr")}</div>
    </div>
  );
};

export default SetlistCountdownRing;
